const clockIcon = `<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 30.168 30.168" style="enable-background:new 0 0 30.168 30.168;" xml:space="preserve">
<g>
\t<g>
\t\t<path style="fill:#010002;" d="M15.084,0C6.754,0,0.001,6.754,0.001,15.084c0,8.331,6.753,15.084,15.083,15.084
\t\t\tc8.331,0,15.083-6.753,15.083-15.084C30.168,6.754,23.416,0,15.084,0z M25.052,22.771l-1.366-1.125
\t\t\tc-0.056-0.047-0.139-0.038-0.185,0.02c-0.046,0.054-0.038,0.137,0.018,0.183l1.375,1.131c-0.549,0.682-1.165,1.306-1.841,1.857
\t\t\tl-1.111-1.421c-0.044-0.056-0.127-0.065-0.184-0.022c-0.057,0.045-0.067,0.128-0.022,0.185l1.109,1.42
\t\t\tc-0.64,0.501-1.33,0.939-2.061,1.312l-0.833-1.575c-0.033-0.065-0.112-0.089-0.176-0.056c-0.064,0.032-0.088,0.113-0.054,0.177
\t\t\tl0.83,1.572c-0.799,0.385-1.641,0.695-2.522,0.906l-0.337-1.886c-0.013-0.072-0.081-0.117-0.151-0.108
\t\t\tc-0.072,0.016-0.119,0.082-0.106,0.153l0.338,1.89c-0.666,0.146-1.346,0.247-2.047,0.282v-2.249c0-0.353-0.286-0.641-0.639-0.641
\t\t\tc-0.354,0-0.641,0.288-0.641,0.641v2.249c-0.584-0.029-1.154-0.109-1.715-0.216l0.283-1.585c0.013-0.071-0.035-0.14-0.106-0.15
\t\t\tc-0.07-0.012-0.139,0.033-0.152,0.104l-0.282,1.58c-0.861-0.182-1.691-0.443-2.476-0.789l0.729-1.383
\t\t\tc0.034-0.064,0.009-0.144-0.055-0.178c-0.063-0.031-0.143-0.007-0.177,0.057L9.76,26.499c-0.736-0.342-1.428-0.758-2.078-1.229
\t\t\tl1.03-1.318c0.044-0.058,0.034-0.14-0.022-0.185c-0.058-0.045-0.14-0.033-0.185,0.022L7.474,25.11
\t\t\tc-0.691-0.525-1.33-1.119-1.899-1.775l1.354-1.113c0.055-0.045,0.064-0.128,0.018-0.186c-0.046-0.054-0.129-0.063-0.185-0.019
\t\t\tL5.4,23.141c-0.552-0.664-1.029-1.392-1.437-2.16l1.595-0.838c0.064-0.033,0.089-0.113,0.055-0.176
\t\t\tc-0.034-0.066-0.112-0.088-0.176-0.057l-1.592,0.836c-0.423-0.84-0.767-1.728-0.995-2.662l1.846-0.345
\t\t\tc0.071-0.013,0.117-0.083,0.104-0.152c-0.014-0.072-0.081-0.117-0.153-0.104l-1.848,0.345c-0.151-0.682-0.257-1.381-0.293-2.101
\t\t\th2.148c0.354,0,0.64-0.286,0.64-0.641c0-0.354-0.287-0.641-0.64-0.641h-2.15c0.036-0.691,0.136-1.365,0.278-2.022
\t\t\tc0.008,0.001,0.012,0.011,0.021,0.011l2.058,0.387c0.008,0.002,0.017,0.002,0.024,0.002c0.062,0,0.116-0.045,0.129-0.107
\t\t\tc0.013-0.071-0.034-0.14-0.104-0.153l-2.059-0.387c-0.007-0.002-0.015,0.004-0.022,0.004c0.227-0.963,0.572-1.88,1.006-2.744
\t\t\tl1.814,0.951c0.019,0.012,0.04,0.018,0.06,0.018c0.047,0,0.093-0.026,0.116-0.069c0.035-0.066,0.01-0.144-0.055-0.177L3.954,9.202
\t\t\tC4.37,8.418,4.855,7.677,5.421,7.001l1.554,1.281c0.026,0.019,0.054,0.029,0.084,0.029c0.038,0,0.075-0.016,0.101-0.047
\t\t\tc0.045-0.057,0.038-0.14-0.018-0.184L5.598,6.809c0.583-0.667,1.236-1.271,1.946-1.802l1.177,1.504
\t\t\tc0.025,0.034,0.064,0.051,0.103,0.051c0.028,0,0.056-0.01,0.08-0.028C8.96,6.488,8.971,6.407,8.927,6.351L7.753,4.849
\t\t\tc0.663-0.478,1.371-0.896,2.122-1.236l0.835,1.581c0.024,0.047,0.069,0.071,0.116,0.071c0.021,0,0.042-0.006,0.062-0.017
\t\t\tc0.063-0.032,0.088-0.111,0.054-0.177l-0.824-1.559c0.806-0.347,1.656-0.605,2.541-0.779l0.312,1.747
\t\t\tc0.011,0.063,0.066,0.108,0.128,0.108c0.008,0,0.016,0,0.024-0.002c0.072-0.014,0.118-0.083,0.105-0.151l-0.312-1.751
\t\t\tc0.503-0.087,1.013-0.155,1.535-0.182c0,0.011-0.006,0.019-0.006,0.027v2.347c0,0.354,0.288,0.641,0.641,0.641
\t\t\ts0.639-0.286,0.639-0.641V2.53c0-0.009-0.004-0.017-0.004-0.027c0.708,0.035,1.397,0.139,2.069,0.286l-0.356,1.993
\t\t\tc-0.013,0.072,0.034,0.14,0.106,0.153c0.008,0.002,0.015,0.002,0.022,0.002c0.062,0,0.118-0.046,0.129-0.107l0.356-1.992
\t\t\tc0.893,0.215,1.742,0.533,2.548,0.925L19.72,5.421c-0.034,0.064-0.01,0.145,0.054,0.178c0.02,0.01,0.041,0.015,0.061,0.015
\t\t\tc0.047,0,0.092-0.025,0.115-0.071l0.877-1.659c0.735,0.377,1.427,0.82,2.068,1.33L21.733,6.7
\t\t\tc-0.045,0.057-0.035,0.138,0.022,0.183C21.781,6.9,21.809,6.91,21.837,6.91c0.039,0,0.077-0.019,0.104-0.051l1.164-1.489
\t\t\tc0.678,0.56,1.292,1.194,1.838,1.885l-1.425,1.173c-0.055,0.045-0.063,0.128-0.018,0.184c0.026,0.033,0.064,0.048,0.101,0.048
\t\t\tc0.03,0,0.059-0.009,0.084-0.03l1.417-1.167c0.524,0.69,0.981,1.432,1.356,2.219l-1.569,0.825
\t\t\tc-0.063,0.031-0.089,0.113-0.055,0.176c0.023,0.045,0.069,0.071,0.116,0.071c0.021,0,0.041-0.006,0.061-0.015l1.564-0.822
\t\t\tc0.382,0.846,0.66,1.747,0.846,2.68l-1.67,0.313c-0.071,0.013-0.117,0.083-0.104,0.152c0.013,0.062,0.067,0.107,0.128,0.107
\t\t\tc0.01,0,0.017,0,0.026-0.004l1.671-0.312c0.093,0.521,0.167,1.049,0.194,1.59H25.5c-0.353,0-0.64,0.287-0.64,0.641
\t\t\ts0.287,0.641,0.64,0.641h2.166c-0.028,0.577-0.11,1.14-0.213,1.693l-1.652-0.311c-0.07-0.011-0.14,0.036-0.154,0.106
\t\t\tc-0.013,0.069,0.034,0.139,0.104,0.152l1.651,0.309c-0.196,0.93-0.482,1.822-0.868,2.663l-1.523-0.799
\t\t\tc-0.063-0.034-0.144-0.01-0.177,0.054c-0.034,0.064-0.008,0.144,0.055,0.176l1.526,0.801
\t\t\tC26.037,21.354,25.578,22.089,25.052,22.771z"/>
\t\t<path style="fill:#010002;" d="M23.305,14.443h-7.179c-0.219-0.355-0.594-0.605-1.042-0.605c-0.146,0-0.281,0.037-0.411,0.085
\t\t\tL9.705,8.955c-0.25-0.251-0.655-0.251-0.905,0c-0.251,0.25-0.251,0.655,0,0.904l5.071,5.072c-0.007,0.054-0.03,0.1-0.03,0.152
\t\t\tc0,0.388,0.182,0.729,0.459,0.959l-3.529,6.264l0.371,0.209l3.529-6.264c0.13,0.046,0.268,0.076,0.414,0.076
\t\t\tc0.448,0,0.822-0.249,1.042-0.604h7.179c0.353,0,0.64-0.286,0.64-0.641C23.945,14.73,23.658,14.443,23.305,14.443z"/>
\t</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;
export default clockIcon;
